import { render, staticRenderFns } from "./SideTitle.vue?vue&type=template&id=ae6fd854&"
import script from "./SideTitle.js?vue&type=script&lang=js&"
export * from "./SideTitle.js?vue&type=script&lang=js&"
import style0 from "./SideTitle.vue?vue&type=style&index=0&id=ae6fd854&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDivider,VIcon,VSpacer,VToolbar,VToolbarTitle})
